import { inject, Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';

@Injectable({
  providedIn: 'root',
})
export class ReferralService {
  private codeCache: { [key: string]: string } = {};

  functions = inject(Functions);

  setReferrer(ref: string) {
    if (typeof localStorage === 'undefined') return;
    const existingRefData = localStorage.getItem('ref');
    const ninetyDaysInMs = 90 * 24 * 60 * 60 * 1000;
    if (existingRefData) {
      try {
        const parsedData = JSON.parse(existingRefData);
        const refAge = Date.now() - parsedData.timestamp;
        if (parsedData.ref && refAge < ninetyDaysInMs) return;
        localStorage.removeItem('ref');
      } catch (error) {
        localStorage.removeItem('ref');
      }
    }
    const refData = { ref: ref, timestamp: Date.now() };
    localStorage.setItem('ref', JSON.stringify(refData));
  }

  getPromoCode() {
    if (typeof localStorage === 'undefined') return null;
    const existingRefData = localStorage.getItem('ref');
    if (!existingRefData) return null;
    try {
      const parsedData = JSON.parse(existingRefData);
      const refAge = Date.now() - parsedData.timestamp;
      const ninetyDaysInMs = 90 * 24 * 60 * 60 * 1000;
      if (!parsedData.ref || refAge > ninetyDaysInMs) {
        throw new Error('Referral data is no longer valid');
      }
      return this.getCodeId(parsedData.ref);
    } catch (error) {
      localStorage.removeItem('ref');
    }
    return null;
  }

  async getCodeId(codeUpper: string) {
    const code = codeUpper.toLowerCase();
    if (this.codeCache[code]) return this.codeCache[code];
    const getPromoCode = httpsCallable<{ code: string }, { id: string }>(
      this.functions,
      'getPromoCode',
    );
    try {
      const result = await getPromoCode({ code });
      const promoCodeId = result.data.id;
      this.codeCache[code] = promoCodeId;
      return promoCodeId;
    } catch (error) {
      console.error('Error fetching promo code:', error);
      return null;
    }
  }
}
